<div>
	<div fxLayout="column" fxFill fxLayoutAlign="flex-end flex-end">
		<button mat-icon-button (click)="onCloseClick()">
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
			/>
		</button>
	</div>
	<div fxLayout="column" fxFill>
		<div ngClass="p-l-l p-r-l">
			<h2 i18n="@@view_summary_heading">
				Summary of offline donation collected by the fundraiser
			</h2>
		</div>
		<section
			*ngIf="!isLoading"
			class="summary-container mat-elevation-z8"
			tabindex="0"
		>
			<table
				fxFlex
				mat-table
				[dataSource]="dataSource"
				class="mat-elevation-z1"
			>
				<!-- Date Column -->
				<ng-container matColumnDef="date">
					<th
						mat-header-cell
						*matHeaderCellDef
						i18n="@@donationSummary_received_donation_header_date"
					>
						Date
					</th>
					<td mat-cell *matCellDef="let dataSource">
						{{
							dataSource.date &&
							dataSource?.date != undefined &&
							dataSource?.date != null &&
							dataSource?.date != '' &&
							dataSource?.date != 0
								? (dataSource?.date | date : 'dd-MM-YYYY')
								: ''
						}}
					</td>
					<td mat-footer-cell *matFooterCellDef>
						<b i18n="@@view_summary_table_header_total">Total</b>
					</td>
				</ng-container>
				<!-- Description Column -->
				<ng-container matColumnDef="description">
					<th
						mat-header-cell
						*matHeaderCellDef
						i18n="@@edit_about_describeAbout_title"
					>
						Description
					</th>
					<td mat-cell *matCellDef="let dataSource">
						{{ dataSource.description }}
					</td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>

				<!-- Cost Column -->
				<ng-container matColumnDef="amount">
					<th
						mat-header-cell
						*matHeaderCellDef
						i18n="@@balance_amount_header_label"
					>
						Amt
					</th>
					<td mat-cell *matCellDef="let dataSource">
						{{ dataSource.currency }} {{ dataSource.amount | number }}
					</td>
					<td mat-footer-cell *matFooterCellDef>
						<b> {{ currency }} {{ getTotalAmount() | number }}</b>
					</td>
				</ng-container>

				<!-- Action column -->
				<ng-container
					matColumnDef="action"
					*ngIf="this.data.isLoggedInUserAdmin"
				>
					<th
						mat-header-cell
						*matHeaderCellDef
						i18n="@@donationSummary_received_donation_header_action"
					>
						Action
					</th>
					<td mat-cell *matCellDef="let dataSource">
						<button
							mat-icon-button
							(click)="openDialog(dataSource.id)"
							[disabled]="!this.data.isLoggedInUserAdmin"
						>
							<mat-icon>edit</mat-icon>
						</button>
					</td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>

				<tr
					mat-header-row
					*matHeaderRowDef="displayedColumns; sticky: true"
				></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				<tr
					mat-footer-row
					*matFooterRowDef="displayedColumns; sticky: true"
				></tr>
			</table>
		</section>
	</div>
</div>
